import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { createPortal } from 'react-dom';

interface NavbarProps {
  cartCount: number;
}

const Navbar: React.FC<NavbarProps> = ({ cartCount }) => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : 'unset';
  }, [isMobileMenuOpen]);

  return (
    <>
      {/* HEADER */}
      <header className="sticky top-0 z-50 w-full border-b border-border-light bg-white/95 backdrop-blur-md">
        <div className="px-4 md:px-10 py-3 max-w-[1400px] mx-auto">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4 md:gap-8">
              <button
                onClick={() => setIsMobileMenuOpen(true)}
                className="md:hidden size-10 flex items-center justify-center"
              >
                <span className="material-symbols-outlined text-3xl">menu</span>
              </button>

              <Link to="/" className="flex items-center gap-3">
                <div className="size-12 text-primary">
		  <img src="/logo.png" alt="Logo" className="h-full w-full object-contain" />
            </div>
                <h2 className="text-xl font-black uppercase italic tracking-tighter">SANAN</h2>
              </Link>

              <nav className="hidden md:flex gap-8 pl-8">
                {[
                  ['/shop', 'Tienda'],
                  ['/collections', 'Colecciones'],
                  ['/custom', 'Personalizar'],
                  ['/about', 'Sobre Nosotros'],
                  ['/contact', 'Contacto'],
                ].map(([path, label]) => (
                  <Link
                    key={path}
                    to={path}
                    className={`text-sm font-bold uppercase tracking-wide border-b-2 py-1 transition-colors ${
                      location.pathname === path
                        ? 'border-black text-black'
                        : 'border-transparent text-gray-500 hover:text-black hover:border-black/10'
                    }`}
                  >
                    {label}
                  </Link>
                ))}
              </nav>
            </div>

            <div className="flex items-center gap-2">

              <Link to="/checkout" className="relative size-10 flex items-center justify-center rounded-lg hover:bg-gray-100">
                <span className="material-symbols-outlined">shopping_cart</span>
                {cartCount > 0 && (
                  <span className="absolute top-1.5 right-1.5 size-4 bg-primary text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                    {cartCount}
                  </span>
                )}
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* MOBILE MENU (PORTAL) */}
      {createPortal(
        <div
          className={`fixed inset-0 z-[999] bg-[#0a0a0a] md:hidden transition-transform duration-500 ${
            isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div className="flex flex-col h-full p-8 bg-[#0a0a0a]">
            <div className="flex justify-between items-center mb-16">
              <Link to="/" className="flex items-center gap-3">
                <div className="size-6">
       		 <img
        	  src="/logo_negro.png"/>
                </div>
                <h2 className="text-xl font-black uppercase italic text-white">SANAN</h2>
              </Link>

              <button
                onClick={() => setIsMobileMenuOpen(false)}
                className="size-12 rounded-full border border-white/10 flex items-center justify-center text-white"
              >
                <span className="material-symbols-outlined text-3xl">close</span>
              </button>
            </div>

            <nav className="flex flex-col gap-10">
              {[
                ['/shop', 'Tienda'],
                ['/custom', 'Personalizar'],
                ['/collections', 'Colecciones'],
                ['/about', 'Sobre Nosotros'],
                ['/contact', 'Contacto'],
              ].map(([path, label]) => (
                <Link
                  key={path}
                  to={path}
                  className={`text-5xl font-black uppercase italic tracking-tighter transition-colors ${
                    location.pathname === path ? 'text-primary' : 'text-white hover:text-primary'
                  }`}
                >
                  {label}
                </Link>
              ))}
            </nav>

            <div className="mt-auto pt-10 border-t border-white/5">

            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default Navbar;
